import { ActionCreator, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import {
  AddTrainingVideoDispatchTypes,
  DeleteTrainingVideoDispatchTypes,
  EditTrainingVideoDispatchTypes,
  GeneratedVideoUrlDispatchTypes,
  TrainingVideoDispatchTypes,
} from "../models/dispatchTypes/Training";
import { ApplicationState } from "../redux/ApplicationState";
import {
  DeleteTrainingVideoActionDispatchTypes,
  GetGeneratedVideoUrlActionDispatchTypes,
  GetTrainingVideoActionDispatchTypes,
  PostTrainingVideoActionDispatchTypes,
  PutTrainingVideoActionDispatchTypes,
} from "../constants/Training";
import {
  DeleteTrainingVideo,
  GetGeneratedVideoUrl,
  GetTrainingVideo,
  PostTrainingVideo,
  PutTrainingVideo,
} from "../services/Training";
import { configUrl } from "../constants/Config";
import toastType from "../utils/SnackbarProvider";
import { MessageType, ResponseMessages } from "../constants/ResponseMessage";

export const getTrainingVideo: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    TrainingVideoDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: GetTrainingVideoActionDispatchTypes.GET_TRAINING_VIDEO_INVOKE,
    });
    const response = await GetTrainingVideo(configUrl);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
          toastType.error(ResponseMessages(MessageType.TRAINING_VIDEO_FAILURE));
          break;
        case 404:
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: GetTrainingVideoActionDispatchTypes.GET_TRAINING_VIDEO_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getGeneratedVideoUrl: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    GeneratedVideoUrlDispatchTypes
  >
> = (url: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: GetGeneratedVideoUrlActionDispatchTypes.GET_GENERATED_VIDEO_URL_INVOKE,
    });
    const response = await GetGeneratedVideoUrl(configUrl, url);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          typeof response.data === "string" && toastType.error(response.data);
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: GetGeneratedVideoUrlActionDispatchTypes.GET_GENERATED_VIDEO_URL_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const deleteTrainingVideo: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    DeleteTrainingVideoDispatchTypes
  >
> = (videoId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: DeleteTrainingVideoActionDispatchTypes.DELETE_TRAINING_VIDEO_INVOKE,
    });
    const response = await DeleteTrainingVideo(configUrl, videoId);

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          typeof response.data === "string" && toastType.error(response.data);
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: DeleteTrainingVideoActionDispatchTypes.DELETE_TRAINING_VIDEO_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const postTrainingVideo: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    AddTrainingVideoDispatchTypes
  >
> = (payload: FormData) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: PostTrainingVideoActionDispatchTypes.POST_TRAINING_VIDEO_INVOKE,
    });
    const response = await PostTrainingVideo(configUrl, payload);
    if (response && response.status) {
      switch (response.status) {
        case 400:
          typeof response.data === "string" && toastType.error(response.data);
          break;
        case 422:
        case 500:
        case 404:
          toastType.error(
            ResponseMessages(MessageType.UPLOAD_TRAINING_VIDEO_FAILURE)
          );
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: PostTrainingVideoActionDispatchTypes.POST_TRAINING_VIDEO_SUCCESS,
          });
          toastType.success(
            ResponseMessages(MessageType.SAVE_TRAINING_VIDEO_SUCCESS)
          );
          break;
        default:
          break;
      }
    }
  };
};

export const putTrainingVideo: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    EditTrainingVideoDispatchTypes
  >
> = (payload: FormData) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: PutTrainingVideoActionDispatchTypes.PUT_TRAINING_VIDEO_INVOKE,
    });
    const response = await PutTrainingVideo(configUrl, payload);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          typeof response.data === "string" && toastType.error(response.data);
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: PutTrainingVideoActionDispatchTypes.PUT_TRAINING_VIDEO_SUCCESS,
          });
          toastType.success(
            ResponseMessages(MessageType.UPDATE_TRAINING_VIDEO_SUCCESS)
          );
          break;
        default:
          break;
      }
    }
  };
};
